import React, {Component} from "react";

class TrustEBrandLogo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <a href="https://privacy.trustarc.com/privacy-seal/validation?rid=9a8ea92d-0044-4919-845d-da59876ab8c6" target="_blank">
        <img style={{border: 'none'}} src="https://hostedseal.trustarc.com/privacy-seal/seal?rid=9a8ea92d-0044-4919-845d-da59876ab8c6" alt="TRUSTe"/>
      </a>
    );
  }
}

export default TrustEBrandLogo;